<template>
  <div>
    <!-- 通知连接状态提示 -->
    <notification-status />
    <link-import-task-runner />

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <!--弹窗：开启低效品下架授权-->
    <el-dialog title="开启低效品下架授权" :visible.sync="delAuthVisible" width="680px">
      <p style="font-weight: 500;margin-bottom: 4px;"> 为提升店铺铺货效率，<span style="color: #ff6363">建议开启“低效品下架授权”</span>。开启后，系统可自动处理低效商品。</p>
      <p style="font-weight: 500;margin-bottom: 10px;">以下抖店尚未开启授权，共计<span style="font-weight: 600">{{authShopList.length}}</span>家店：</p>
      <el-table border :data="authShopList" size="small" max-height="500px">
        <el-table-column label="店铺名称" prop="shop_name"></el-table-column>
      </el-table>
      <div class="tips">
        <div class="tips-title">说明:</div>
        <div>
          · 每日额度规则：未授权0；已授权低动销未达标 min(50,Q)，低动销达标 min(500,Q,H)；非低动销未达标300，非低动销达标 min(500,H)。<br/>
          · Q为低动销每日额度缓存；H为本系统30天考核窗口可铺数量，按窗口在架数、有效动销数和旧快照铺货扣减计算。<br/>
          · 已授权额度字段缺失时兼容回退50；若Q已知且更低，则按Q执行，最低可为0。<br/>
          · {{ lowSalesAuthorizationRestriction }}<br/>
          · 一键开启将对列表内全部店铺开启低效品下架授权，并记录操作日志。
        </div>
      </div>
      <template #footer>
        <el-button @click="delAuthVisible=false">拒绝</el-button>
        <el-button type="primary" :loading="authLoading" @click="handleAuth">一键开启授权</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import config from '@/assets/js/conf/config'
import NotificationStatus from '@/components/NotificationStatus.vue'
import LinkImportTaskRunner from '@/components/LinkImportTaskRunner.vue'


// 通知类型对应的图标和颜色
const notificationConfig = {
  import_progress: { icon: 'el-icon-upload', color: '#667eea', title: '导入进度' },
  order: { icon: 'el-icon-document', color: '#f5576c', title: '订单通知' },
  system: { icon: 'el-icon-setting', color: '#4facfe', title: '系统消息' },
  task: { icon: 'el-icon-time', color: '#43e97b', title: '任务通知' },
  alert: { icon: 'el-icon-warning', color: '#fa709a', title: '告警通知' }
}

export default {
  name: 'app',
  components: {
    NotificationStatus,
    LinkImportTaskRunner,

  },
  data() {
    return {
      lastNotificationId: null,
      notificationInitialized: true,
      processedNotificationIds: new Set(), // 已处理的通知ID集合
      delAuthVisible:false,
      authShopList:[],//待授权抖店
      shopTime:null,//低效品下架授权定时器
      unauthorized_quantity:0,//未开启
      authorized_quantity:50,//已开启
      authLoading:false
    }
  },
  computed: {
    lowSalesAuthorizationRestriction() {
      return '开启后，在店铺商品应用授权有效且未到期期间，不可关闭“授权下架低效品”；应用授权失效或到期后方可关闭。'
    },
    ...mapState('login', ['token']),
    ...mapState('notification', ['wsConnected', 'notifications', 'lastAddedNotification']),
    ...mapGetters('notification', ['wsState', 'isWSFailed'])
  },
  watch: {
    // 监听 token 变化，登录后自动连接实时通知
    token: {
      handler(newToken, oldToken) {
        if (newToken && !oldToken) {
          // 登录成功，连接实时通知
          this.initNotificationWS()
        } else if (!newToken && oldToken) {
          // 退出登录，断开实时通知
          this.disconnectNotificationWS()
        }
      },
      immediate: false
    },

    // 监听最后添加的通知，有新通知时弹出提示
    lastAddedNotification: {
      handler(newNotification) {
        if (!newNotification || !newNotification.id) return

        // 检查是否已经处理过这个通知（避免重复弹窗）
        // 特殊情况：如果是导入完成（status=completed 或 进度100%），即使ID已存在也允许再次弹窗
        const isCompleted = newNotification.status === 'completed' ||
                           (newNotification.progress !== undefined && parseInt(newNotification.progress) >= 100)
        const isImportCompleted = newNotification.type === 'import_progress' && isCompleted

        if (!this.processedNotificationIds.has(newNotification.id) || isImportCompleted) {
          this.processedNotificationIds.add(newNotification.id)

          // 延迟一下，确保通知已经添加到列表
          this.$nextTick(() => {
            const notification = this.notifications.find(n => n.id === newNotification.id)
            if (notification) {
              this.showNotificationPopup(notification)
            }
            this.lastNotificationId = newNotification.id
          })
        }
      },
      immediate: false,
      deep: true
    },

    // 监听实时通知连接状态，失败时弹出提示
    wsState: {
      handler(newState, oldState) {
        // 当状态变为 failed 时，显示右上角弹窗
        if (newState === 'failed' && oldState !== 'failed') {
          this.$notify({
            title: '通知服务连接困难',
            message: '正在持续尝试重新连接，不影响其他功能使用。如长时间无法连接，请检查网络或刷新页面。',
            type: 'warning',
            duration: 8000, // 8秒后自动关闭
            position: 'top-right',
            offset: 60,
            showClose: true
          })
        }

        // 当从 failed 状态恢复连接时，显示成功提示
        if (oldState === 'failed' && newState === 'connected') {
          this.$notify({
            title: '通知服务已连接',
            message: '实时通知功能已恢复正常',
            type: 'success',
            duration: 3000,
            position: 'top-right',
            offset: 60
          })
        }
      },
      immediate: false
    }
  },
  mounted() {
    // 如果已经登录，初始化实时通知连接
    const token = localStorage.getItem(config.tokenKey)
    if (token) {
      this.initNotificationWS()
      this.$nextTick(() => {
        setTimeout(() => {
          this.notificationInitialized = true
          // 将已存在的通知ID加入已处理集合
          if (this.notifications && this.notifications.length > 0) {
            this.notifications.forEach(n => {
              if (n.id) {
                this.processedNotificationIds.add(n.id)
              }
            })
            this.lastNotificationId = this.notifications[0]?.id || null
          }
        }, 1500) // 增加延迟时间，确保初始化完成
      })
      //低效品下架授权弹出
      const lowSalesTime = localStorage.getItem('lowSalesTime')
      const targetTime = parseFloat(lowSalesTime)+10*60*1000
      const now = new Date().getTime()
      const time=lowSalesTime&&targetTime>now?targetTime-now:0
      setTimeout(()=>{
          this.getAuthShop()
          this.shopTime = setInterval(()=>{
            this.getAuthShop()
          },10*60*1000)
      },time)
    }

    // 请求桌面通知权限
    this.requestNotificationPermission()
  },

  beforeDestroy() {
    // 组件销毁时断开实时通知
    this.disconnectNotificationWS()
    //销毁低效品下架授权定时器
    clearInterval(this.shopTime)
  },
  methods: {
    // ...mapActions('notification', ['initNotificationWS', 'disconnectNotificationWS']),
    ...mapActions({
      initNotificationWS:"notification/initNotificationWS",
      disconnectNotificationWS:'notification/disconnectNotificationWS',
      getDdShopList: "ucenter/getDdShopList",
      opLowSalesProductDeleteAuthorization: "ucenter/opLowSalesProductDeleteAuthorization",
    }),

    // 请求桌面通知权限
    requestNotificationPermission() {
      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission()
      }
    },

    // 显示通知弹窗
    showNotificationPopup(notification) {
      const config = notificationConfig[notification.type] || {
        icon: 'el-icon-bell',
        color: '#409eff',
        title: '新消息'
      }

      const h = this.$createElement

      this.$notify({
        title: notification.title || config.title,
        message: h('div', { style: 'line-height: 1.6' }, [
          h('p', { style: 'margin: 0; color: #606266; font-size: 14px;' },
            notification.content || notification.message || '您有一条新通知'
          ),
          // 如果是导入完成，显示刷新提示
          (notification.type === 'import_progress' && (notification.status === 'completed' || (notification.progress !== undefined && parseInt(notification.progress) >= 100)))
            ? h('p', { style: 'margin: 8px 0 0 0; color: #E6A23C; font-size: 12px; font-weight: 500;' }, '请点击右上角刷新列表')
            : null,
          // 如果是导入进度，显示进度条
          notification.type === 'import_progress' && notification.progress !== undefined
            ? h('el-progress', {
                props: {
                  percentage: notification.progress,
                  status: notification.progress >= 100 ? 'success' : ''
                },
                style: 'margin-top: 8px;'
              })
            : null
        ]),
        type: this.getNotificationType(notification.type),
        duration: 5000,
        position: 'top-right',
        offset: 60,
        onClick: () => {
          this.handleNotificationClick(notification)
        }
      })
    },

    // 根据通知类型返回Element UI的type
    getNotificationType(type) {
      const typeMap = {
        alert: 'warning',
        order: 'info',
        system: 'info',
        import_progress: 'info',
        task: 'success'
      }
      return typeMap[type] || 'info'
    },

    // 点击通知弹窗
    handleNotificationClick(notification) {
      // 根据类型跳转
      if (notification.link || notification.url) {
        this.$router.push(notification.link || notification.url)
      } else if (notification.type === 'order') {
        this.$router.push('/uc_order')
      } else if (notification.type === 'import_progress') {
        this.$router.push('/uc_product?menuId=131')
      } else {
        // 跳转到通知中心
        this.$router.push('/notification')
      }
    },

    /**
     * —— 低效品删除授 ——*/
    getAuthShop(){
      const token = localStorage.getItem(config.tokenKey)
      if(!token){
        clearInterval(this.shopTime)
        localStorage.removeItem('lowSalesTime')
        return
      }
      this.getDdShopList({
        data:{shop_type:1, low_sales_product_delete_authorized:0},
        success:(res)=>{
          if(res.code==200){
            localStorage.setItem('lowSalesTime',new Date().getTime())
            this.authShopList =res.data?.list?.list??[]
            this.unauthorized_quantity  =res.data?.unauthorized_quantity??0
            this.authorized_quantity  =res.data?.authorized_quantity??50
            if(this.authShopList.length) this.delAuthVisible=true
          }
        }
      })
    },
    handleAuth(){
      if (this.authLoading || !this.authShopList.length) return
      this.$confirm(this.lowSalesAuthorizationRestriction, '开启授权提示', {
        confirmButtonText: '确认开启',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitAuth()
      }).catch(() => {})
    },
    submitAuth(){
      if (this.authLoading || !this.authShopList.length) return
      const params={
        shop_ids:this.authShopList.map(i=>i.dd_shop_id),
        low_sales_product_delete_authorized:1
      }
      this.authLoading=true
      this.opLowSalesProductDeleteAuthorization({
        data:params,
        success:(res)=>{
          if(res.code==200){
            this.$message.success(`已成功开启${this.authShopList.length}家店铺的低效品下架授权。`)
            this.delAuthVisible=false
            window.dispatchEvent(new Event('low-sales-authorization-updated'))
          }else {
            this.$message.error(res.msg||res.message)
          }
          this.authLoading=false
        },
        fail:()=>{
          this.$message.error('网络异常，请稍后重试')
          this.authLoading=false
        }
      })
    },
  }
}
</script>

<style scoped>
.tips{
  padding: 10px;
  border-radius: 6px;
  background:#f5f7fa;
  font-size: 13px;
  color: #ff6363;
  line-height: 1.7;
  margin-top: 14px;
}
.tips-title{
  font-weight: 600;
  margin-bottom: 8px;
  color: #333333;
  font-size: 15px;
}
</style>
